import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import SiteHeader from './SiteHeader'
import SiteFooter from './SiteFooter'
import ConsentBanner from './ConsentBanner'
import Analytics from '../Analytics'

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-paper text-ink">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <SiteHeader />
      <main id="main" tabIndex={-1} className="flex-1">
        <Suspense fallback={<p className="px-6 py-16 font-mono text-sm">Loading…</p>}>
          <Outlet />
        </Suspense>
      </main>
      <SiteFooter />
      <ConsentBanner />
      <Analytics />
    </div>
  )
}
